import React, { useEffect, useState, useRef } from "react";
import "./MyTickets.css";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import ProgressBar from "@ramonak/react-progress-bar";
import ArticleIcon from "@mui/icons-material/Article";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CancelRounded from "@mui/icons-material/CancelRounded";
import { IconButton, Typography } from '@mui/material';
import Close from "@mui/icons-material/Close";
import CheckRounded from "@mui/icons-material/CheckRounded";
import EditRow from "../EditRow/EditRow";
import NextResParty from "../NextResParty/NextResParty";
import CancelIcon from "@mui/icons-material/Cancel";
import ChangeStatus from "../Status/ChangeStatus";
import { MentionsInput, Mention } from "react-mentions";
import { LinearProgress } from "@mui/material";
import EditList from "../EditListAssign/EditList";
import accimg from "../images/accimg.png";
import personImg from "../images/person_image.png";
import EditAttachment from "../EditFile/EditAttachment";
import axiosApiInstance from "../axios";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import {
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  Switch,
  Button,
  TextField,
  Chip,
  Tooltip,
} from "@mui/material";
import Card from "@mui/material/Card";
import { dateTimeFormat } from "../utils/common";
import Backdrop from "@mui/material/Backdrop";
import Autocomplete from "@mui/material/Autocomplete";
import _ from "lodash";
import { saveAs } from "file-saver";
import CAlertBox from "../CAlertBox/CAlertBox";
import Modal from "react-modal";

const limit = 10;
let scrollDebounce = false;
let assignedTicketsScrollDebounce = false;

const MyTickets = ({ term, called, prio }) => {
  const [inputData, setInputData] = useState("");
  const [text, settext] = useState([]);
  const [ticketCount, setTicketCount] = useState([]);
  const [ticketNumber, setTicketNumber] = useState();
  const [selectTicket, setSelectTicket] = useState([]);
  const [savedComments, setSavedComments] = useState([]);
  const [ticketAttachments, setTicketAttachments] = useState([]);
  const [isApproveCommentErrMsg, setIsApproveCommentErrMsg] = useState(false);
  const [isApproveUserErrMsg, setIsApproveUserErrMsg] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('');

  let Id = called;
  const [showStatus, setShowStatus] = useState(false);
  const [approvalData, setApprovalData] = useState({});

  const [showIgn, setShowIgn] = useState(false);

  const [sugg, setSugg] = useState([]);

  const [showFile, setShowFile] = useState(false);

  const [isActiveTicket, setIsActiveTicket] = useState();
  const [selectedUser, setSelectedUser] = useState(0);
  const [showSelectedUsers, setShowSelectedUsers] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [comment, setComment] = useState("");
  const [approverLoader, setApproverLoader] = useState(false);

  const textChange = (e) => {
    setInputData(e.target.value.split("@@@^^^").join(" "));
  };

  const [loading, setLoading] = useState(false);
  const [loadNew, setLoadNew] = useState(false);
  const [activityLoader, setActivityLoader] = useState(false);
  const [approvalLoader, setApprovalLoader] = useState(false);
  const [stopPagination, setStopPagination] = useState(false);
  const [stopAssignedTicketsPagination, setStopAssignedTicketsPagination] =
    useState(false);
  const [isApproverEdit, setIsApproverEdit] = useState(false);
  const employeeId = JSON.parse(localStorage.getItem("id"));
  const userRoles = JSON.parse(localStorage.getItem("userRole"));
  const [higherRole, setHigherRole] = useState("");
  const [assignOptions, setAssignOptions] = useState([]);
  const [assignValue, setAssignValue] = useState({});
  let pageNumber = 1;
  const [alertDeleteMessage, setAlertDeleteMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [deleteFileName, setdeleteFileName] = useState("");
  const [dispTab, setDispTab] = useState([]);

  const [responsible, setResponsible] = useState([]);
  const [open, setOpen] = useState(false);
  const [showAct, setShowAct] = useState(false);
  const [showComment, setShowComment] = useState(true);
  const [showApproval, setShowApproval] = useState(false);
  const [showParty, setShowParty] = useState(false);
  const [showApprover, setShowApprover] = useState(false);
  const [loader, setLoader] = useState(false);


  useEffect(() => {
    if (userRoles?.includes("TMS-UI-Admin")) {
      setHigherRole("TMS-UI-Admin");
    } else {
      setHigherRole("");
    }
  }, []);

  const savePeopleDetails = () => {
    let data = JSON.stringify({
      ticketId: ticketNumber,
      assignId: assignValue.id,
    });

    axiosApiInstance
      .post("/ticket/AddAssignee", data)
      .then(function (response) {
        if (response.data.succeeded) {
          getNextResponsiblePartyData();
        }
      })
      .catch((error) => {
        console.log("error : ", error);
      });
    setShowIgn(false);
  };

  const loadMore = () => {
    if (!stopPagination) {
      setLoader(true);
      axiosApiInstance
        .get(`/ticket/GetTicketsByStatus/${pageNumber}/${limit}/${Id}`)
        .then((res) => {
          setLoader(false);
          if (res.status === 200) {
            if (res.data.data.length < limit) {
              setStopPagination((prevValue) => {
                return true;
              });
            }

            setTicketCount((prevState) => [...prevState, ...res.data.data]);
            pageNumber += 1;
          }
        });
    }
  };

  useEffect(() => {
    setTicketCount([]);
    setStopPagination(false);
    setApprovalData([]);
    setDispTab([]);
  }, [Id]);

  const handleScroll = (e) => {
    if (
      window.innerHeight + e.target.documentElement.scrollTop + 1 >=
        e.target.documentElement.scrollHeight &&
      !stopPagination &&
      !scrollDebounce
    ) {
      scrollDebounce = true;
      loadMore();
      setTimeout(function () {
        scrollDebounce = false;
      }, 500);
    }
  };

  let tic = ticketCount[0];
  useEffect(() => {
    if (tic) {
      const firstValue = Object.values(tic)[0];
      setTicketNumber(firstValue);
      setIsActiveTicket(firstValue);
    }
  }, [ticketCount]);

  let page = 1;
  let assingedTicketsPage = 1;

  setTimeout(() => {
    setLoadNew(false);
  }, 2000);

  useEffect(() => {
    loadMore();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [stopPagination, Id]);

  useEffect(() => {
    getTicketDetails();
    if(open){
      editTicket();
    }
  }, [ticketNumber]);

  const getTicketDetails = () => {
    if (ticketNumber) {
      axiosApiInstance
        .get(`/ticket/${ticketNumber}`)
        .then((response) => {
          setSelectTicket(response.data.data);
          setLoading(false);
          setSavedComments(response.data.data.comments);
          setTicketAttachments(response.data.data.attachments);
          setShowSelectedUsers([...response.data.data.approverDto]);
          setComment(response.data.data.approvalRequestDto.requestComment);
          setSelectedUser(response.data.data.approverDto[0]?.isAllUser ? 1 : 0);
          setShowApprover(false);
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    setIsApproverEditable(showSelectedUsers, approvalData);
  }, [showSelectedUsers, approvalData]);

  const setIsApproverEditable = (data, approvalStatus) => {
    setIsApproverEdit(true);
    if (
      selectTicket.status === "Work Completed" ||
      selectTicket.status === "Closed"
    ) {
      setIsApproverEdit(false);
    } else {
      if (higherRole === "TMS-UI-Admin") {
        if (
          approvalStatus?.approved === "Rejected" ||
          approvalStatus?.approved === "Approved"
        ) {
          setIsApproverEdit(false);
        }
      } else {
        data.forEach((element) => {
          if (element.isApproved !== null) {
            setIsApproverEdit(false);
          }
        });
      }
    }
  };

  useEffect(() => {
    if (showSelectedUsers.length > 0) {
      getApprovalData();
    }
  }, [showSelectedUsers]);

  const getApprovalData = () => {
    if (ticketNumber) {
      setApprovalLoader(true);
      axiosApiInstance
        .get(`/approval/${ticketNumber}`)
        .then((response) => {
          if (response.data.succeeded) {
            setApprovalData(response.data.data);
            setApprovalLoader(false);
          } else {
            setApprovalData({});
            if (showApproval) {
              setShowComment(true);
              setShowApproval(false);
            }
          }
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    getNextResponsiblePartyData();
  }, [ticketNumber]);

  const getNextResponsiblePartyData = () => {
    if (ticketNumber) {
      axiosApiInstance
        .get(`/nextResponsible/${ticketNumber}`)
        .then((res) => setResponsible(res.data.data))
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    axiosApiInstance
      .get("/user/EmployeeList")
      .then((res) => setSugg(res.data.data))
      .catch((err) => console.log(err));
  }, []);


  useEffect(() => {
    if (ticketNumber && showAct && dispTab.length === 0) {
      getactivityDetails();
    }
  }, [ticketNumber, open, showParty, showAct, dispTab]);

  const getactivityDetails = () => {
    setActivityLoader(true);

    axiosApiInstance
      .get(`/activity/${ticketNumber}`)
      .then((res) => {
        setDispTab(res.data.data);
        setActivityLoader(false);
      })
      .catch((err) => console.log(err));
  };

  const onShowClick = () => {
    setShowAct(true);
    setShowComment(false);
    setShowApproval(false);
  };

  const onChangeAssignValues = (e, value) => {
    setAssignValue(value);
  };

  const onComClick = () => {
    setShowAct(false);
    setShowComment(true);
    setShowApproval(false);
  };

  const onApprovalClick = () => {
    setShowAct(false);
    setShowComment(false);
    setShowApproval(true);
    getApprovalData();
  };

  const addComment = () => {
    if (!inputData) {
    } else {
      axiosApiInstance.post("/Comments", data).then(function (response) {
        if (response.data.succeeded) {
          getTicketDetails();
        }
      });
      settext([...text, inputData]);
      setInputData("");
    }
  };

  let data = JSON.stringify({
    ticketId: ticketNumber,
    comments: inputData,
  });

  const editTicket = () => {
    setOpen(!open);
  };

  const editParty = () => {
    setShowParty(!showParty);
  };

  const editStat = () => {
    setShowStatus(!showStatus);
  };

  const [checked, setChecked] = useState(false);
  const [nxtTix, setNxtTix] = useState([]);

  const loadNext = () => {
    if (!stopAssignedTicketsPagination) {
      GetAssignedTicketsByStatus();
    }
  };
  const GetAssignedTicketsByStatus = () =>{
    axiosApiInstance
    .get(`/ticket/GetAssignedTicketsByStatus/${pageNumber}/${limit}/${Id}`)
    .then((res) => {
      if (res.status === 200) {
        if (res.data.data.length < limit) {
          setStopAssignedTicketsPagination((prevValue) => {
            return true;
          });
        }

        setNxtTix((prevState) => [...prevState, ...res.data.data]);
        pageNumber += 1;
      }
    });
  }
  const getSmallString = (string) => {
    let newString = string.split(".");
    let resultString = (
      newString[0].length > 15
        ? newString[0].substring(0, 15)?.concat("...")
        : newString[0]
    ).concat(
      newString[0].length > 15 ? `(.${newString[1]})` : `.${newString[1]}`
    );
    return resultString;
  };

  useEffect(() => {
    setNxtTix([]);
    setStopAssignedTicketsPagination(false);
  }, [Id]);

  const OnSwitchChange = (e) => {
    setChecked(e.target.checked);
  };

  const scrollHandle = (e) => {
    if (
      window.innerHeight + e.target.documentElement.scrollTop + 1 >=
        e.target.documentElement.scrollHeight &&
      !stopAssignedTicketsPagination &&
      !assignedTicketsScrollDebounce
    ) {
      assignedTicketsScrollDebounce = true;
      loadNext();
      setTimeout(function () {
        assignedTicketsScrollDebounce = false;
      }, 500);
    }
  };

  const onChangeAssignValuesMultiSelect = (e, values, reason, detail) => {
    const seen = new Set();
    const filteredArr = values.filter((el) => {
      const duplicate = seen.has(el.id);
      seen.add(el.id);
      return !duplicate;
    });
    setSelectedValues(filteredArr);
    if (values.length > 0) {
      setIsApproveUserErrMsg("");
    }
  };

  setTimeout(() => {
    setLoadNew(false);
  }, 2000);

  useEffect(() => {
    if (userRoles?.includes("TMS-UI-Admin")) {
      loadNext();
      window.addEventListener("scroll", scrollHandle);
    return () => {
      window.removeEventListener("scroll", scrollHandle);
    };      
    }
  }, [open, showParty, showStatus, called, stopAssignedTicketsPagination]);

  const editIgn = () => {
    setShowIgn(!showIgn);
  };

  const editFile = () => {
    setShowFile(!showFile);
  };

  const downloadFile = (filename) => {
    axiosApiInstance
      .get(`/File/${ticketNumber}/${filename}`, { responseType: "blob" })
      .then((res) => {
        if (res.status === 200) {
          let urlArray = res.config.url && res.config.url.split("/");
          let fileName = urlArray[urlArray.length - 1];
          let blob = new Blob([res.data], { type: "application/octet-stream" });
          saveAs(blob, fileName);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const openDeletefile = (fileName) => {
    setdeleteFileName(fileName);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const deletefile = () => {
    let data = {
      ticketId: `${ticketNumber}`,
      fileName: deleteFileName,
    };

    axiosApiInstance
      .post("/File/Delete", JSON.stringify(data))
      .then((res) => {
        if (res?.data?.succeeded === true) {
          setTicketAttachments(
            ticketAttachments.filter((x) => x.fileName !== deleteFileName)
          );
          setIsOpen(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const onCommentChange = (event) => {
    setComment(event.target.value);
    if (event.target.value !== "") {
      setIsApproveCommentErrMsg(false);
    }
  };

  setTimeout(() => {
    setLoadNew(false);
  }, 2000);

  const onApprovalSave = () => {
    if (comment === "") {
      setIsApproveCommentErrMsg(true);
    }

    if (selectedValues.length <= 0) {
      setIsApproveUserErrMsg(true);
    }

    if (comment !== "" && selectedValues.length > 0) {
      setApproverLoader(true);

      let approversIds = selectedValues.map((item) => item.id);

      let data = {
        ticketId: selectTicket.ticketId,
        comment: comment,
        approvalId: approversIds,
        isAllUser: !!parseInt(selectedUser),
      };

      axiosApiInstance
        .post("/approval", JSON.stringify(data))
        .then((res) => {
          if (res?.data?.succeeded === true) {
            setShowApprover(false);
            getTicketDetails();
            setApproverLoader(false);
            getApprovalData();
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const onInputChange = _.debounce((e, value, fromApprover = false) => {
    setDeleteMessage('')
    if (value !== "") {
      axiosApiInstance
        .get(`/user/${value}`)
        .then((response) => {
          if (response.data.succeeded) {
            let updatedArray = response.data.data.map((item) => {
              if (fromApprover) {
                if (item.id !== employeeId) {
                  return { id: item.id, name: item.display };
                } else {
                  return null;
                }
              } else {
                return { id: item.id, name: item.display };
              }
            });
            setAssignOptions(updatedArray.filter((item) => item !== null));
          }
        })
        .catch((err) => console.log(err));
    } else {
      setAssignOptions([]);
    }
  }, 500);

  const onApproverExpandCancelClick = () => {
    setShowApprover(!showApprover);
    if (!showApprover) {
      setSelectedValues([...showSelectedUsers]);
    }
  };

  const onRemove = (id) =>{
    let data = JSON.stringify({
      ticketId: ticketNumber,
      assignId: id,
    });

    axiosApiInstance
      .delete(`/ticket/DeleteAssignee?ticketId=${ticketNumber}&assignId=${id}`, data)
      .then(function (response) {
        if (response.data.succeeded) {
          setDeleteMessage(response.data.message);
          setTimeout(()=>{
            getNextResponsiblePartyData();
          },1000)
        }
      })
      .catch((error) => {
        setDeleteMessage('Error Occured');
      });
  };
 
  useEffect(()=>{
    if(deleteMessage != ''){
      setTimeout(()=>{
        setDeleteMessage('');
      },1500)
    }
  },[deleteMessage])

  useEffect(()=>{
    if(checked){
      axiosApiInstance
      .get(`/ticket/GetAssignedTicketsByStatus/${pageNumber}/${limit}/${Id}`)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.data.length < limit) {
            setStopAssignedTicketsPagination((prevValue) => {
              return true;
            });
          }
  
          setNxtTix([...res.data.data]);
          pageNumber += 1;
        }
      });
    }
  },[checked])

  return (
    <div className="ticket-parent">
     {loader 
      ? 
      <div className="noId">
        <CircularProgress />
      </div>
      :
      <div className="tickets-list">
        <div className="left-div">
          {higherRole === "TMS-UI-Admin" ? (
            <div className="top-ticket">
              <p>Created Tickets</p>
              <div>
                <Switch onChange={OnSwitchChange} checked={checked} />
              </div>
              <p>Assigned Tickets</p>
            </div>
          ) : (
            <div className="top-ticket">
              <p>Created Tickets</p>
            </div>
          )}
          {
            higherRole === "TMS-UI-Admin" ?
            <>
            {!checked ? (
                        <>
                          {ticketCount?.length === 0
                            ? "Sorry you don't have any tickets"
                            : ticketCount &&
                              ticketCount
                                .filter((tix) => {
                                  if (
                                    tix?.title?.toLowerCase()?.includes(term.toLowerCase())
                                  ) {
                                    return tix;
                                  } else if (
                                    tix.projectTag
                                      .toLowerCase()
                                      .includes(term.toLowerCase())
                                  ) {
                                    return tix;
                                  } else if (
                                    tix.ticketId
                                      .toString()
                                      .toLowerCase()
                                      .includes(term.toLowerCase())
                                  ) {
                                    return tix;
                                  }
                                })
                                .filter((tix) => {
                                  if (prio === 0) {
                                    return tix;
                                  } else {
                                    return tix.priority === prio;
                                  }
                                })
                                .map((tix, index) => (
                                  <div
                                    className={
                                      (tix.priority === "High" &&
                                        tix.ticketId === isActiveTicket &&
                                        "single-list activered") ||
                                      (tix.priority === "Low" &&
                                        tix.ticketId === isActiveTicket &&
                                        "single-list activeyellow") ||
                                      (tix.priority === "Medium" &&
                                        tix.ticketId === isActiveTicket &&
                                        "single-list activegreen") ||
                                      (tix.ticketId !== isActiveTicket &&
                                        tix.priority === "High" &&
                                        "single-list red") ||
                                      (tix.ticketId !== isActiveTicket &&
                                        tix.priority === "Low" &&
                                        "single-list yellow") ||
                                      (tix.ticketId !== isActiveTicket &&
                                        tix.priority === "Medium" &&
                                        "single-list green")
                                    }
                                    key={index}
                                    onClick={() => {
                                      setTicketNumber(tix.ticketId);
                                      setIsActiveTicket(tix.ticketId);
                                      setApprovalData([]);
                                      if (tix.ticketId !== isActiveTicket) {
                                        setLoading(true);
                                        setDispTab([]);
                                        getApprovalData();
                                      }
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    <div className="single-list-title" key={index}>
                                      <p>ID {tix.ticketId}</p>
                                      <OpenInNewIcon
                                        className="icon-new"
                                        style={{ color: "#3169bd" }}
                                      />
                                    </div>
                                    <div className="single-list-desc">{tix.title}</div>
                                    <div className="single-list-details">
                                      <div className="single-list-stat">
                                        <p>Status</p>
                                        <span>{tix.status}</span>
                                      </div>
                                      <div
                                        className="single-list-rest"
                                        style={{ width: "55%" }}
                                      >
                                        <p>Project</p>
                                        <span>{tix.projectTag}</span>
                                      </div>
                                      <div
                                        className="single-list-rest"
                                        style={{ width: "70%" }}
                                      >
                                        <p>Category</p>
                                        <span>
                                          {tix.category && tix.category?.length > 12 ? (
                                            <Tooltip title={tix.category}>
                                              <p>
                                                {tix.category
                                                  ?.substring(0, 12)
                                                  ?.concat("...")}
                                              </p>
                                            </Tooltip>
                                          ) : (
                                            <p>{tix.category}</p>
                                          )}
                                        </span>
                                      </div>
                                      <div className="single-list-rest due">
                                        <p>Due Date</p>
                                        <span>{dateTimeFormat(tix.dueDate, true)}</span>
                                      </div>
                                    </div>
                                    <div className="single-list-created">
                                      <p>Created on {dateTimeFormat(tix.submittedDate)}</p>
                                    </div>
                                  </div>
                                ))}{" "}
                        </>
                       ) : (
                        <>
                          {" "}
                          {nxtTix?.length === 0
                            ? "Sorry you don't have any tickets"
                            : nxtTix &&
                              nxtTix
                                .filter((nxts) => {
                                  if (
                                    nxts.title.toLowerCase().includes(term.toLowerCase())
                                  ) {
                                    return nxts;
                                  } else if (
                                    nxts.projectTag
                                      .toLowerCase()
                                      .includes(term.toLowerCase())
                                  ) {
                                    return nxts;
                                  } else if (
                                    nxts.ticketId
                                      .toString()
                                      .toLowerCase()
                                      .includes(term.toLowerCase())
                                  ) {
                                    return nxts;
                                  }
                                })
                                .filter((nxts) => {
                                  if (prio === 0) {
                                    return nxts;
                                  } else {
                                    return nxts.priority === prio;
                                  }
                                })
                                .map((nxts, index) => (
                                  <div
                                    className={
                                      (nxts.priority === "High" &&
                                        nxts.ticketId === isActiveTicket &&
                                        "single-list activered") ||
                                      (nxts.priority === "Low" &&
                                        nxts.ticketId === isActiveTicket &&
                                        "single-list activeyellow") ||
                                      (nxts.priority === "Medium" &&
                                        nxts.ticketId === isActiveTicket &&
                                        "single-list activegreen") ||
                                      (nxts.ticketId !== isActiveTicket &&
                                        nxts.priority === "High" &&
                                        "single-list red") ||
                                      (nxts.ticketId !== isActiveTicket &&
                                        nxts.priority === "Low" &&
                                        "single-list yellow") ||
                                      (nxts.ticketId !== isActiveTicket &&
                                        nxts.priority === "Medium" &&
                                        "single-list green")
                                    }
                                    key={index}
                                    onClick={() => {
                                      setTicketNumber(nxts.ticketId);
                                      setIsActiveTicket(nxts.ticketId);
                                      setLoading(true);
                                      setDispTab([]);
                                      setApprovalData([]);
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    <div className="single-list-title" key={index}>
                                      <p>ID {nxts.ticketId}</p>
                                      <OpenInNewIcon
                                        className="icon-new"
                                        style={{ color: "#3169bd" }}
                                      />
                                    </div>
                                    <div className="single-list-desc">{nxts.title}</div>
                                    <div className="single-list-details">
                                      <div className="single-list-stat">
                                        <p>Status</p>
                                        <span>{nxts.status}</span>
                                      </div>
                                      <div
                                        className="single-list-rest"
                                        style={{ width: "55%" }}
                                      >
                                        <p>Project</p>
                                        <span>{nxts.projectTag}</span>
                                      </div>
                                      <div
                                        className="single-list-rest"
                                        style={{ width: "100%" }}
                                      >
                                        <p>Category</p>
                                        <span>
                                          {nxts.category && nxts.category?.length > 12 ? (
                                            <Tooltip title={nxts.category}>
                                              <p>
                                                {nxts.category
                                                  ?.substring(0, 12)
                                                  ?.concat("...")}
                                              </p>
                                            </Tooltip>
                                          ) : (
                                            <p>{nxts.category}</p>
                                          )}
                                        </span>
                                      </div>
                                      <div className="single-list-rest due">
                                        <p>Due Date</p>
                                        <span>{dateTimeFormat(nxts.dueDate, true)}</span>
                                      </div>
                                    </div>
                                    <div className="single-list-created">
                                      <p>Created on {dateTimeFormat(nxts.submittedDate)}</p>
                                    </div>
                                  </div>
                                ))}
                        </>
                      )}
                        </>: (
              
              ticketCount?.length === 0
                ? "Sorry you don't have any tickets"
                : ticketCount &&
                  ticketCount
                    .filter((tix) => {
                      if (
                        tix?.title?.toLowerCase()?.includes(term.toLowerCase())
                      ) {
                        return tix;
                      } else if (
                        tix.projectTag
                          .toLowerCase()
                          .includes(term.toLowerCase())
                      ) {
                        return tix;
                      } else if (
                        tix.ticketId
                          .toString()
                          .toLowerCase()
                          .includes(term.toLowerCase())
                      ) {
                        return tix;
                      }
                    })
                    .filter((tix) => {
                      if (prio === 0) {
                        return tix;
                      } else {
                        return tix.priority === prio;
                      }
                    })
                    .map((tix, index) => (
                      <div
                        className={
                          (tix.priority === "High" &&
                            tix.ticketId === isActiveTicket &&
                            "single-list activered") ||
                          (tix.priority === "Low" &&
                            tix.ticketId === isActiveTicket &&
                            "single-list activeyellow") ||
                          (tix.priority === "Medium" &&
                            tix.ticketId === isActiveTicket &&
                            "single-list activegreen") ||
                          (tix.ticketId !== isActiveTicket &&
                            tix.priority === "High" &&
                            "single-list red") ||
                          (tix.ticketId !== isActiveTicket &&
                            tix.priority === "Low" &&
                            "single-list yellow") ||
                          (tix.ticketId !== isActiveTicket &&
                            tix.priority === "Medium" &&
                            "single-list green")
                        }
                        key={index}
                        onClick={() => {
                          setTicketNumber(tix.ticketId);
                          setIsActiveTicket(tix.ticketId);
                          setApprovalData([]);
                          if (tix.ticketId !== isActiveTicket) {
                            setLoading(true);
                            setDispTab([]);
                            getApprovalData();
                          }
                          window.scrollTo(0, 0);
                        }}
                      >
                        <div className="single-list-title" key={index}>
                          <p>ID {tix.ticketId}</p>
                          <OpenInNewIcon
                            className="icon-new"
                            style={{ color: "#3169bd" }}
                          />
                        </div>
                        <div className="single-list-desc">{tix.title}</div>
                        <div className="single-list-details">
                          <div className="single-list-stat">
                            <p>Status</p>
                            <span>{tix.status}</span>
                          </div>
                          <div
                            className="single-list-rest"
                            style={{ width: "55%" }}
                          >
                            <p>Project</p>
                            <span>{tix.projectTag}</span>
                          </div>
                          <div
                            className="single-list-rest"
                            style={{ width: "100%" }}
                          >
                            <p>Category</p>
                            <span>
                              {tix.category && tix.category?.length > 12 ? (
                                <Tooltip title={tix.category}>
                                  <p>
                                    {tix.category
                                      ?.substring(0, 12)
                                      ?.concat("...")}
                                  </p>
                                </Tooltip>
                              ) : (
                                <p>{tix.category}</p>
                              )}
                            </span>
                          </div>
                          <div className="single-list-rest due">
                            <p>Due Date</p>
                            <span>{dateTimeFormat(tix.dueDate, true)}</span>
                          </div>
                        </div>
                        <div className="single-list-created">
                          <p>Created on {dateTimeFormat(tix.submittedDate)}</p>
                        </div>
                      </div>
                    ))
          
            )
           
          }

          
          {loadNew ? <LinearProgress /> : ""}
        </div>
      </div>}
      {ticketCount?.length === 0 || (prio && prio !== selectTicket.priority) ? (
        <div className="noId">
          <p>No Data Available</p>
        </div>
      ) : (
        <>
          {!selectTicket.ticketId ? (
            <div className="noId">
              <CircularProgress />
            </div>
          ) : (
            <div className="my-ticket-area-duplicate">
              <div className="div-left-duplicate">
                {loading ? (
                  <LinearProgress className="left-loader" />
                ) : (
                  <>
                    <span className="my-span">
                      ID - {selectTicket.ticketId}
                    </span>
                    <span className="my-span-2">{selectTicket.title}</span>
                    <div className="my-ticket-description-duplicate formatted-text">
                      {selectTicket.description}
                    </div>
                    <div className="my-tickets-head">
                      <span
                        className={
                          showComment
                            ? "my-tickets-comments-head little"
                            : "my-tickets-comments-head"
                        }
                        onClick={onComClick}
                      >
                        COMMENTS
                      </span>

                      <span
                        className={
                          showAct
                            ? "my-tickets-comments-act little"
                            : "my-tickets-comments-act"
                        }
                        onClick={onShowClick}
                      >
                        ACTIVITY
                      </span>

                      {showSelectedUsers.length > 0 && (
                        <span
                          className={
                            showApproval
                              ? "my-tickets-comments-act little"
                              : "my-tickets-comments-act"
                          }
                          onClick={onApprovalClick}
                        >
                          APPROVAL
                        </span>
                      )}
                    </div>
                    {showComment ? (
                      <div className="user-input-section-duplicate">
                          <MentionsInput
                            className="mentions--multiLine"
                            placeholder="Enter Comment"
                            value={inputData}
                            onChange={textChange}
                          >
                            <Mention
                              trigger="@"
                              data={sugg}
                              markup="__display__@@@^^^"
                              className="mention-dis"
                            />
                          </MentionsInput>
                          <button onClick={addComment}>Save</button>
                        {savedComments &&
                          savedComments
                            .map((tixd, num) => (
                              <div className="comments-display" key={num}>
                                <div className="comment-head">
                                  <img
                                    src={
                                      tixd.profilePath
                                        ? tixd.profilePath
                                        : accimg
                                    }
                                    className="img-pro"
                                  />
                                  <p className="title-comment">
                                    {tixd.fullName}
                                  </p>
                                  <p className="title-note">
                                    added a comment -{" "}
                                  </p>
                                  <p className="title-time">
                                    {dateTimeFormat(tixd.createdDate)}
                                  </p>
                                </div>
                                <div className="comment-content format">
                                  {tixd.comments}
                                </div>
                              </div>
                            ))
                            .sort()
                            .reverse()}
                      </div>
                    ) : showAct ? (
                      activityLoader ? (
                        <div className="noId">
                          <CircularProgress />
                        </div>
                      ) : (
                        <div className="user-input-section-duplicate"> 
                          {dispTab.length < 1
                            ? "No Activity Yet"
                            : dispTab.map((disp, id) => (
                                <div className="card-body">
                                  <Card>
                                    <div
                                      className={
                                        disp.status === "Opened"
                                          ? "table-body opened"
                                          : disp.status === "In-Progress"
                                          ? "table-body Inprogress"
                                          : disp.status === "Work Completed"
                                          ? "table-body workcompleted"
                                          : ["Closed", "Re-Opened", "Pending For Approval"].includes(disp.status)
                                          ? "table-body closed"
                                          : "table-body default"
                                      }
                                      key={id}
                                    >
                                      <span>
                                        Title <p>{disp.title}</p>
                                      </span>
                                      <span>
                                        Status <p>{disp.status}</p>
                                      </span>
                                      <span>
                                        Category <p>{disp.category}</p>
                                      </span>
                                      <span>
                                        Client <p>{disp.client}</p>
                                      </span>
                                      <span>
                                        Next Responsible{" "}
                                        <p>{disp.nextResponsible}</p>
                                      </span>
                                      <span>
                                        Project <p>{disp.project}</p>
                                      </span>
                                      <span>
                                        Priority <p>{disp.priority}</p>
                                      </span>
                                      <span>
                                        Created Date{" "}
                                        <p>
                                          {dateTimeFormat(disp.createdDate)}
                                        </p>
                                      </span>
                                    </div>
                                  </Card>
                                </div>
                              ))}
                        </div>
                      )
                    ) : approvalLoader ? (
                      <div className="noId">
                        <CircularProgress />
                      </div>
                    ) : Object.keys(approvalData).length > 0 ? (
                      <div className="mytickets-approval-section-container">
                        <div>
                          <b className="mytickets-approval-section-main-title">
                            Approval Request
                          </b>
                          <div className="mytickets-approval-user-container">
                            <div className="mytickets-approval-user-time-container">
                              <img
                                className="mytickets-approver-person-image"
                                src={personImg}
                              />
                              <b className="mytickets-approval-section-user-name">
                                {approvalData.approvalRequest.name}
                              </b>
                              <b className="mytickets-approval-section-time">
                                {approvalData.approvalRequest.requestedDate &&
                                  dateTimeFormat(
                                    approvalData.approvalRequest.requestedDate
                                  )}
                              </b>
                            </div>
                            <div style={{ paddingLeft: 25 }}>
                              <label className="mytickets-approval-section-description">
                                {approvalData.approvalRequest.requestComment}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div>
                          <b className="mytickets-approval-section-main-title">
                            Approval Response
                          </b>
                          {approvalData.approvalResponse.map((item, index) => (
                            <div className="mytickets-approval-user-container">
                              <div className="mytickets-approval-user-time-container">
                                <img
                                  className="mytickets-approver-person-image"
                                  src={personImg}
                                />
                                <b className="mytickets-approval-section-user-name">
                                  {item.name}
                                </b>
                                <b className="mytickets-approval-section-time">
                                  {item.approvedDate &&
                                    dateTimeFormat(item.approvedDate)}
                                </b>
                                {item.isApproved === null ? (
                                  <div
                                    className="mytickets-approval-section-chip"
                                    style={{
                                      padding: "3px 20px",
                                      backgroundColor: "#999",
                                    }}
                                  >
                                    <label className="mytickets-approval-sub-chip-text">
                                      PENDING
                                    </label>
                                  </div>
                                ) : item.isApproved ? (
                                  <div className="mytickets-approval-section-chip">
                                    <CheckRounded
                                      sx={{
                                        color: "#FFF",
                                        backgroundColor: "#22A",
                                        borderRadius: 10,
                                        padding: 0,
                                        height: 15,
                                        width: 15,
                                      }}
                                    />{" "}
                                    <label className="mytickets-approval-sub-chip-text">
                                      APPROVED
                                    </label>
                                  </div>
                                ) : (
                                  <div
                                    className="mytickets-approval-section-chip"
                                    style={{
                                      backgroundColor: "#f0754d",
                                      paddingRight: 17,
                                    }}
                                  >
                                    <Close
                                      sx={{
                                        color: "#FFF",
                                        backgroundColor: "#db6139",
                                        borderRadius: 10,
                                        padding: 0,
                                        height: 15,
                                        width: 15,
                                      }}
                                    />{" "}
                                    <label className="mytickets-approval-sub-chip-text">
                                      REJECTED
                                    </label>
                                  </div>
                                )}
                              </div>
                              <div style={{ paddingLeft: 25 }}>
                                <label className="mytickets-approval-section-description">
                                  {item.responseComment}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : null}
                  </>
                )}
              </div>

              <div className="div-center-duplicate">
                <div className="status-progress">
                  <h1>Ticket Status</h1>
                  {selectTicket.status !== "Pending For Approval" && (
                    <span className="edit-span" onClick={editStat}>
                      {showStatus ? <CancelIcon className="hover-active-icon" /> : <EditIcon className="hover-active-icon"/>}
                    </span>
                  )}
                </div>
                {showStatus ? (
                  <ChangeStatus
                    setIsTicketStatusChanged={(value = false) => {
                      if (value === true) {
                        getTicketDetails();
                        getactivityDetails();
                      }
                    }}
                    onStatChange={editStat}
                    info={ticketNumber}
                    stat={selectTicket.status}
                    strtDate={selectTicket.submittedDate}
                  />
                ) : (
                  <span
                    className={
                      (selectTicket.status === "Opened" && "stat-open") ||
                      (selectTicket.status === "Closed" && "stat-close") ||
                      (selectTicket.status === "In-Progress" &&
                        "stat-progress") ||
                      (selectTicket.status === "Work Completed" &&
                        "stat-work") ||
                      (selectTicket.status === "Pending For Approval" &&
                        "stat-pending") ||
                        (selectTicket.status === "New" &&
                          "stat-new")
                    }
                  >
                    {selectTicket.status}
                  </span>
                )}

                {/* <ProgressBar completed={25} completedClassName="my-progress-bar" /> */}
                <div className="add-attach">
                  <h1>Attachment</h1>
                  <span className="icon-attach" onClick={editFile}>
                    {showFile ? <CancelIcon className="hover-active-icon"/> : <AddIcon className="hover-active-icon"/>}
                  </span>
                  {/* <input
            type="file"
            id="file"
            ref={inputFile}
            style={{ display: "none" }}
         /> */}
                  {/* <Add onClick={addAttach} className="icon-attach"/> */}
                </div>
                {showFile ? (
                  <EditAttachment
                    setIsTicketStatusChanged={(value = false) => {
                      if (value === true) {
                        getTicketDetails();
                      }
                    }}
                    onfChange={editFile}
                    info={ticketNumber}
                  />
                ) : (
                  <>
                    {ticketAttachments < 1 ? (
                      <p class="empty-attach">None</p>
                    ) : (
                      ticketAttachments &&
                      ticketAttachments.map((attach, id) => (
                        <>
                          <div className="single-attachment" key={id}>
                            <div className="attach-text">
                              <ArticleIcon className="attachment-icon" />
                              <div className="attachment-text">
                                <p>{getSmallString(attach.fileName)}</p>
                                <p>{attach.size}</p>
                              </div>
                            </div>
                            <div className="attach-con">
                              <FileDownloadOutlinedIcon
                                className="file-attach-icon"
                                type="button"
                                onClick={() => {
                                  downloadFile(attach.fileName);
                                }}
                              >
                                Download
                              </FileDownloadOutlinedIcon>
                              <DeleteOutlineOutlinedIcon
                                className="delete-icon"
                                type="button"
                                onClick={() => openDeletefile(attach.fileName)}
                              />
                            </div>
                          </div>
                        </>
                      ))
                    )}
                  </>
                )}

                <div className="resParty-next">
                  <h1>Next Responsible Party</h1>
                  <span className="edit-span" onClick={editParty}>
                    {showParty ? <CancelIcon className="hover-active-icon" /> : <EditIcon className="hover-active-icon"/>}
                  </span>
                </div>
                {!showParty ? (
                  <>
                    <p key={ticketNumber} className="res-p">
                      {selectTicket.nextResponsible}
                    </p>
                  </>
                ) : (
                  " "
                )}
                {showParty ? (
                  <NextResParty
                    setIsNextResPartyChanged={(value = false) => {
                      if (value === true) {
                        getTicketDetails();
                        getactivityDetails();
                      }
                    }}
                    onPartyChange={editParty}
                    info={ticketNumber}
                    selectedUser={selectTicket.nextResponsible}
                  />
                ) : (
                  ""
                )}

                <div className="mytickets-approver-container">
                  <div className="mytickets-approver-plus-container">
                    <b className="mytickets-approver-text">Approver</b>
                    {isApproverEdit && (
                      <span
                        className="icon-attach"
                        style={{ fontSize: "13.3px" }}
                        onClick={onApproverExpandCancelClick}
                      >
                        {showApprover ? <CancelIcon className="hover-active-icon"/> :  <AddIcon className="hover-active-icon"/>}
                      </span>
                    )}
                  </div>
                  {!showApprover ? (
                    showSelectedUsers.length > 0 ? (
                      <>
                        <div className="mytickets-approver-chips-container-main">
                          {showSelectedUsers.map((item, index) => (
                            <div className="mytickets-approver-chips-container">
                              <img
                                className="mytickets-approver-person-image"
                                src={personImg}
                              />{" "}
                              <b className="myticets-approver-outside-chip-text">
                                {item.name}
                              </b>{" "}
                              {item.isApproved ===
                              null ? null : item.isApproved ? (
                                <CheckCircle sx={{ color: "#44D" }} />
                              ) : (
                                <CancelRounded sx={{ color: "#D66" }} />
                              )}
                            </div>
                          ))}
                        </div>
                        <RadioGroup
                          className="mytickets-radio-buttons-container"
                          row
                          aria-label="priority"
                          name="row-radio-buttons-group"
                          value={selectedUser}
                        >
                          <FormControlLabel
                            disabled
                            value={0}
                            control={<Radio size="small" />}
                            label="Any Approver"
                            className="myticket-radio-button-label"
                          />
                          <FormControlLabel
                            disabled
                            value={1}
                            control={<Radio size="small" />}
                            label="All Approver"
                            className="myticket-radio-button-label"
                          />
                        </RadioGroup>
                      </>
                    ) : (
                      <p class="empty-attach">None</p>
                    )
                  ) : (
                    <div>
                      <textarea
                        placeholder="Comment"
                        value={comment}
                        onChange={(event) => onCommentChange(event)}
                        rows={2}
                        className="mytickets-textarea-style"
                      />
                      {isApproveCommentErrMsg && (
                        <label className="mytickets-validation-text">
                          This field is required
                        </label>
                      )}
                      <div className="mytickets-approver-sub-container">
                        <Autocomplete
                          id="free-solo-demo"
                          className="newticket-autocomplete-style"
                          freeSolo
                          multiple
                          value={selectedValues}
                          onChange={(event, value, reason, detail) =>
                            onChangeAssignValuesMultiSelect(
                              event,
                              value,
                              reason,
                              detail
                            )
                          }
                          duplicate={false}
                          onInputChange={(e, v) => onInputChange(e, v, true)}
                          options={assignOptions}
                          getOptionLabel={(option) => option.name}
                          renderInput={(params) => (
                            <TextField {...params} 
                            placeholder="Select Approver"
                            InputProps={{
                              ...params.InputProps,
                              style: { paddingRight: '40px' }, // Add spacing for clear button
                            }}
                            />
                          )}
                          renderTags={(values, getTagProps) => {
                            const seen = new Set();
                            const filteredArr = values.filter((el) => {
                              const duplicate = seen.has(el.id);
                              seen.add(el.id);
                              return !duplicate;
                            });
                            return filteredArr.map((option, index) => (
                              <Chip
                                style={{ marginRight: 10 }}
                                label={option.name}
                                {...getTagProps({ index })}
                              ></Chip>
                            ));
                          }}
                        />
                        {isApproveUserErrMsg && (
                          <label className="mytickets-validation-text">
                            This field is required
                          </label>
                        )}
                        <RadioGroup
                          className="mytickets-radio-buttons-container"
                          row
                          aria-label="priority"
                          name="row-radio-buttons-group"
                          value={selectedUser}
                          onChange={(e) => {
                            setSelectedUser(e.target.value);
                          }}
                        >
                          <FormControlLabel
                            value={0}
                            control={<Radio size="small" />}
                            label="Any Approver"
                            className="myticket-radio-button-label"
                          />
                          <FormControlLabel
                            value={1}
                            control={<Radio size="small" />}
                            label="All Approver"
                            className="myticket-radio-button-label"
                          />
                        </RadioGroup>
                        <div className="mytickets-save-cancel-buttons">
                          <Button
                            className="mytickets-save-button"
                            onClick={onApprovalSave}
                          >
                            Save
                          </Button>
                          <Button
                            className="mytickets-cancel-button"
                            onClick={() => {
                              setShowApprover(false);
                              setSelectedValues([...showSelectedUsers]);
                            }}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="mytickets-approval-status-container">
                  <label className="mytickets-approval-status-title">
                    Approval Status
                  </label>
                  <label className="mytickets-approval-status-text">
                    {approvalData?.approved ? (
                      approvalData?.approved
                    ) : (
                      <p class="empty-attach">None</p>
                    )}
                  </label>
                </div>

                <div className="my-details-head">
                  <h1>Details</h1>
                  <span className="edit-span" onClick={editTicket}>
                    {open ? <CancelIcon className="hover-active-icon" /> : <EditIcon className="hover-active-icon"/>}
                  </span>
                </div>
                <div className="my-details-content">
                  {open ? (
                    <EditRow
                      setIsDetailsChanged={(value = false) => {
                        if (value === true) {
                          getTicketDetails();
                          getactivityDetails();
                        }
                      }}
                      onStateChange={editTicket}
                      info={ticketNumber}
                    />
                  ) : (
                    <>
                      <div className="details-div">
                        <span>ID</span> <p>{selectTicket.ticketId}</p>
                      </div>
                      <div className="details-div">
                        <span>Title</span>{" "}
                        <p>
                          {selectTicket?.title &&
                          selectTicket?.title?.length > 15
                            ? selectTicket?.title
                                ?.substring(0, 15)
                                ?.concat("...")
                            : selectTicket?.title}
                        </p>
                      </div>
                      <div className="details-div">
                        <span>Project Tag</span>{" "}
                        <p>{selectTicket.projectTag}</p>
                      </div>
                      <div className="details-div">
                        <span>Client Name</span>{" "}
                        <p>{selectTicket.clientName}</p>
                      </div>
                      <div className="details-div">
                        <span>Priority</span> <p>{selectTicket.priority}</p>
                      </div>
                      <div className="details-div">
                        <span>Category</span> <p>{selectTicket.category}</p>
                      </div>
                      <div className="details-div">
                        <span>Sub Category</span>{" "}
                        <p>
                          {selectTicket?.subCategory &&
                          selectTicket?.subCategory?.length > 15
                            ? selectTicket?.subCategory
                                ?.substring(0, 15)
                                ?.concat("...")
                            : selectTicket?.subCategory}
                        </p>
                      </div>
                      <div className="details-div">
                        <span>Submitted By</span>{" "}
                        <p>{selectTicket.submittedBy}</p>
                      </div>
                      <div className="details-div">
                        <span>Submitted Date</span>{" "}
                        <p>
                          {dateTimeFormat(selectTicket.submittedDate, true)}
                        </p>
                      </div>
                      <div className="details-div">
                        <span>Due Date</span>{" "}
                        <p>{dateTimeFormat(selectTicket.dueDate, true)}</p>
                      </div>
                    </>
                  )}
                </div>
                <div className="peep">
                  <h1>People</h1>
                  <p className="edit-p" onClick={editIgn}>
                    {showIgn ? <CancelIcon className="hover-active-icon" /> : <EditIcon className="hover-active-icon"/>}
                  </p>
                </div>
                {showIgn ? (
                  <div className="at-approver-sub-container">
                    <Autocomplete
                      id="free-solo-demo"
                      className="at-autocomplete-style"
                      freeSolo
                      onChange={(event, value) =>
                        onChangeAssignValues(event, value)
                      }
                      duplicate={false}
                      onInputChange={(e, v) => onInputChange(e, v)}
                      options={assignOptions}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="select" />
                      )}
                    />
                    <div className="at-save-cancel-buttons">
                      <Button
                        className="at-save-button"
                        onClick={savePeopleDetails}
                      >
                        Save
                      </Button>
                      <Button
                        className="at-cancel-button"
                        onClick={() => setShowIgn(false)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="people">
                    {responsible.map((nxt) => (
                      <>
                        <div key={nxt.id} className="peo-frag" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <img
                              src={nxt.profilePath ? nxt.profilePath : accimg}
                              className="img-pro"
                              alt="profile"
                              style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                            />
                          <p style={{ margin: 0, flexGrow: 1 }}>{nxt.fullName}</p>
                          <IconButton onClick={() => onRemove(nxt.id)} aria-label="remove" size="small">
                            <Close />
                          </IconButton>
                        </div>
                      </>
                    ))}
                     {deleteMessage !== '' && (
                            <Typography variant="body2" color="red">
                              {deleteMessage}
                            </Typography>
                          )}
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}

      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={closeModal}
        contentLabel="Modal"
        className="modal-popup"
        shouldCloseOnOverlayClick={false}
      >
        <p className="Modal-open-text">
          Are you sure you want delete {deleteFileName} file?
        </p>

        <div className="delete-art">
          <Button className="delete-art-save" onClick={deletefile}>
            DELETE
          </Button>
          <Button className="delete-art-close" onClick={closeModal}>
            CANCEL
          </Button>
        </div>
      </Modal>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={approverLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default MyTickets;
